(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[473],{

/***/ 23868:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-clinics/travel-clinic/travel-clinic-locations",
      function () {
        return __webpack_require__(39293);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68527);
/* harmony import */ var components_CMS__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60100);
/* harmony import */ var components_stores__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49647);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TravelClinicLocations = function(param) {
    var content = param.content, travelClinics = param.travelClinics;
    var ref, ref1;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (content === null || content === void 0 ? void 0 : content.pageAlertBanner) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS__WEBPACK_IMPORTED_MODULE_1__/* .Banner */ .jL, _objectSpread({
                isPageAlertBanner: true
            }, content === null || content === void 0 ? void 0 : content.pageAlertBanner)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS__WEBPACK_IMPORTED_MODULE_1__/* .Hero */ .VM, {
                        data: content
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
                        spacing: "10",
                        marginY: {
                            base: '5',
                            md: '10'
                        },
                        alignItems: "center",
                        children: [
                            content === null || content === void 0 ? void 0 : (ref = content.bodyCollection) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(_param, index) /*#__PURE__*/ {
                                var __typename = _param.__typename, rest = _objectWithoutProperties(_param, [
                                    "__typename"
                                ]);
                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS__WEBPACK_IMPORTED_MODULE_1__/* .ComponentGenerator */ .LZ, _objectSpread({
                                    __typename: __typename
                                }, rest), "component-".concat(index));
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_stores__WEBPACK_IMPORTED_MODULE_2__/* .FindTravelClinic */ .g6, {
                                travelClinics: travelClinics
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (TravelClinicLocations);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [578,647,774,888,179], function() { return __webpack_exec__(23868); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);